import styled from 'styled-components';

export const BoxText = styled.div`
    margin-bottom: 20px;
    text-align: center;
`;
